module.exports = __webpack_public_path__ + "static/media/IMG_0127.b3dac072.jpg";